<template>
    <div class="navs">
        <!-- <div class="logo"><img src="../assets/vlogo.jpg" alt="logo" /></div> -->
        <el-menu mode="vertical"  :default-active="activePathIndx" background-color="#496cfc" text-color="#c5d3f8"
            active-text-color="#fff" @select="activeStoreIndx">
            <el-submenu index="1">
                <template slot="title">企业管理</template>
                <el-menu-item-group>

                    <el-menu-item index="1-1">
                        <router-link to="/home/companyList"> 企业列表 </router-link>
                    </el-menu-item>
                    <el-menu-item index="1-2">
                        <router-link to="/home/companyStat"> 企业统计 </router-link>
                    </el-menu-item>
                    <el-menu-item index="1-3">
                        <router-link to="/home/companyPerson"> 人员列表 </router-link>
                    </el-menu-item>
                    <el-menu-item index="1-4">
                        <router-link to="/home/companyCount"> 区间统计 </router-link>
                    </el-menu-item>
                    <el-menu-item index="1-5">
                        <router-link to="/home/companySub"> 机构列表 </router-link>
                    </el-menu-item>
                    <el-menu-item index="1-6">
                        <router-link to="/home/companyPolicyAdmin"> 添加被保人员 </router-link>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>

        </el-menu>
    </div>
</template>

<script>

export default {
    data() {
        return {
            userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
            activePathIndx: sessionStorage.getItem('activePathIndx') || '1-1'

        }
    },
    methods: {
        activeStoreIndx(indx, indxPath) {
            console.log("indxPath", indxPath)
            sessionStorage.setItem('activePathIndx', indxPath[indxPath.length - 1])
        },
    }
};
</script>

<style scoped>
.navs {
    height: 100%;
    background-color: #496cfc;
    overflow: hidden;
    overflow-y: auto;
}

.el-menu-item a {
    color: rgb(197 211 248);
    display: block;
}

.el-menu-item.is-active a {
    color: #fff;
}

.logo {
    background-color: #496cfc;
    height: 60px;
    text-align: center;
}

.logo img {
    height: 45px;
    margin-top: 7.5px;
}
</style>
